import { render, staticRenderFns } from "./WhiteSpotsLayer.vue?vue&type=template&id=4b80451c"
import script from "./WhiteSpotsLayer.vue?vue&type=script&lang=js"
export * from "./WhiteSpotsLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports